import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'daysAndHours',
})
export class DaysAndHoursPipe implements PipeTransform {
  transform(daysAndHours: any, units: string, stdWorkdayHours: number, hideUnits: undefined, roundValue: undefined): any {
    var daysAndHourss = parseFloat(daysAndHours);
    if (!stdWorkdayHours) stdWorkdayHours = 8;
    if (!daysAndHourss || daysAndHourss == 0) {
      if (units == 'H') return '0' + (hideUnits ? '' : ' hrs');
      else if (units == 'D') return '0' + (hideUnits ? '' : ' days');
    } else {
      if (units == 'H') {
        if (roundValue) return Math.round(daysAndHourss) + (hideUnits ? '' : ' hrs');
        else return parseFloat(daysAndHourss.toFixed(2)) + (hideUnits ? '' : ' hrs');
      } else if (units == 'D') {
        var days = daysAndHourss / stdWorkdayHours;
        if (roundValue) return Math.round(days) + (hideUnits ? '' : ' days');
        return parseFloat(days.toFixed(2)) + (hideUnits ? '' : ' days');
      }
    }
    //return parseFloat(daysAndHours.toFixed(2)) + "hrs";
    return 0;
  }
}
